/*
 * The texts of the widgets extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	buttons: {
		dashboard: {
			add_widget: 'Widget hinzufügen',
			save: 'Dashboard speichern',
			delete_all: 'Alle Widgets löschen',
		},
	},
	// Display names of the lib's dashboard widgets, key derived from the type (see dashboard registry)
	widgets: {
		me: {
			title: 'Mein Profil',
		},
		date_time: {
			title: 'Datum und Uhrzeit',
		},
	},
	confirms: {
		dashboard: {
			delete_widget: {
				title: 'Widget löschen',
				text: 'Soll das Widget "{name}" vom Dashboard entfernt werden?',
			},
			delete_all: {
				title: 'Alle Widgets löschen',
				text: 'Soll das Widget vom Dashboard entfernt werden? | Sollen alle {count} Widgets vom Dashboard entfernt werden?',
			},
		},
	},
};
